import { Backdrop } from "@mui/material";
import React from "react";
import assest from "../../json/assest";

const ApiLoader = ({ loading }) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 10 }}
      open={loading}
      // onClick={handleClose}
      className="loader"
        >
      {/* <FadeLoader color="#5C5C5C" /> */}
      <div className="loader-wrapper">
        <div className="loaderIcon">
          <img src={assest.logo_loader} alt="img" width={100} height={100} />
        </div>
      </div>
    </Backdrop>
  );
};

export default ApiLoader;
